import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import { normalizeJsxAttribute } from "shared/lib/utils";

import type { ContentSchemaRenderProps } from "scmp-app/components/schema-render/content";

import { StyledDiv, StyledParagraph } from "./styles";

export type Props = ContentSchemaRenderProps & {
  isStaticPage?: boolean;
};

const Component: FunctionComponent<Props> = ({ children, schemaNode, ...attribs }) => {
  const hasImageOrLinkInChildren = (schemaNode: SchemaNode): boolean =>
    ["a", "img"].includes(schemaNode.type);

  const Component = schemaNode.children?.some(node => hasImageOrLinkInChildren(node))
    ? StyledDiv
    : StyledParagraph;

  return (
    <Component
      datatype={schemaNode.type}
      {...normalizeJsxAttribute(schemaNode.attribs)}
      {...attribs}
    >
      {children}
    </Component>
  );
};

Component.displayName = "Paragraph";
export const Paragraph = styled(Component)``;
